module.exports = {"title":"그린관제시스템","lastUpdated":"최근 업데이트","refresh":"새로고침","selectGolfClubPlaceholder":"골프클럽을 선택하세요.","totalApl":"전체 APL","serviceOperating":"서비스 운영","serviceWaiting":"서비스 대기","lowBattery":"배터리 부족","report":"보고","normal":"정상","error":"오류","batteryStatus":"배터리 상태","chargeRequired":"충전 필요","temperature":"온도","aplStatus":"APL 상태","batteryLevel":"배터리 잔량","operating":"운영","noData":"데이터가 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/gr001.json
// module id = 5xeJ
// module chunks = 2